// smartMart.stikyACT-related.js
// last updates: events debug
// version: 20260903-1358
document.addEventListener('DOMContentLoaded', (e) => {
	window.smartMart_stickyACTrelated = window.smartMart_stickyACTrelated || {};
	smartMart_stickyACTrelated.hdr= '[smartMart_stickyACTrelated]:';
	smartMart_stickyACTrelated.version = '0.1.1_b';

	// window Events:
	window.addEventListener('videowiseProductAddToCart', (e) => {
		const stickyATCselector = '#sticky_add_to_cart_root:has(#bundle-sticky_add_to_cart.Vtl-StickyAddToCart)';
		const stickyATCelement = document.querySelector(stickyATCselector);
		if ( // exists an unhidden yet .............................................
			stickyATCelement &&
			stickyATCelement.style.display != 'none'
		) {
			// process hide, log case
			stickyATCelement.style.display = 'none';
			console.log(`${smartMart_stickyACTrelated.hdr} sticky ATC hidden on window ${e.type}`);
		} else {
			// log case
			console.log(`${smartMart_stickyACTrelated.hdr} no sticky ATC element found or already hidden`);
		}
	});

	// document Events:
	document.addEventListener('ajaxProduct:added', (e) => {
		//### console.log(`${smartMart_stickyACTrelated.hdr} ${e.type} e:`,e);

		const stickyATCselector = '#sticky_add_to_cart_root:has(#bundle-sticky_add_to_cart.Vtl-StickyAddToCart)';
		const stickyATCelement = document.querySelector(stickyATCselector);
		if ( // exists an unhidden yet .............................................
			stickyATCelement &&
			stickyATCelement.style.display != 'none'
		) {
			// process hide, log case
			stickyATCelement.style.display = 'none';
			console.log(`${smartMart_stickyACTrelated.hdr} sticky ATC hidden on document ${e.type}`);
		} else {
			// log case
			console.log(`${smartMart_stickyACTrelated.hdr} no sticky ATC element found or already hidden`);
		}
	});
	document.addEventListener('ajaxProduct:error', (e) => {
		//###
		console.error(`${smartMart_stickyACTrelated.hdr} ${e.type} e:`,e);
		//TODO: process error case soon (?..)
	});

	document.addEventListener('variant:change', (e) => {
		//###
		console.log(`${smartMart_stickyACTrelated.hdr} ${e.type} e:`,e);
	});

	// log done
	console.log(`${smartMart_stickyACTrelated.hdr} ${smartMart_stickyACTrelated.version} done`);
});
